<template>
  <div class="gameplan">
    <div class='normal_title'>{{getConfigTitle}}</div>
    <div class="normal_box is_hover_shadow">
      <div class="activity_form_box">
        <el-form :inline="true" :model="params" ref="activityNewform" label-position="left" :rules="editRules">
          <el-form-item label="活动形式" label-width="140px" >
            <el-checkbox-group @change="handleActivityFormChange()" v-model="themeStyles">
              <div class="activity_form_item" v-for="(item) in itemInfo.themeStyles" :key="item.themeChannelCode">
                <el-checkbox @change="changeThemeStyles(item)" :label="item.themeStyleName">
                  {{item.themeStyleName}}
                </el-checkbox>
                <ConfigItemSecondSelect v-if="hasSecond(item)&&isChecked(item.themeStyleName)" :selectItem="item" ref="ConfigItemSecondSelectRef"
                  @handleThemeStylesSecond="handleThemeStylesSecond" @handleChangeStyle="handleChangeStyle" :saveThemeStylesSecond="item.themeStylesSecond"/>
              </div>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <div v-show="inputError" class="warning">请输入额度分配！</div>
      </div>
    </div>

    <div class="tab_box" v-if="themeStylesValidOrder.length>0">
      <div class="tab">
        <el-tabs v-model="secondActiveName" type="card">
            <el-tab-pane v-for="(item) of themeStylesValidOrder" :key="(item.themeStyleCode)" :label="item.themeStyleName" :name="item.themeStyleName">
              <div class="tab_item_box">
                <div class="tab_item_context">
                  <div v-if="hasSecond(item)">
                    <ConfigItemHq ref="configDetailHq" :item="item" :itemInfo="itemInfo" :styleInfo="item" :fullConfig="fullConfig" :assignBuList="assignBuList"
                      :assignRegionList="assignRegionList" @handleSubmit="handleSubmit" @handleInputError="handleInputError" :assignAreaList="assignAreaList" :configItem="configItem"></ConfigItemHq>
                  </div>
                  <div v-else>
                    <ConfigDetailHq ref="configDetailRef" levelIndex="0" @handleSubmit="handleSubmit" :baseConfig="itemInfo" :themeStyles1="item" :styleInfo="item" :assignAreaList="assignAreaList"
                      :fullConfig="fullConfig" :assignBuList="assignBuList" :assignRegionList="assignRegionList" :saveDetailList="item.otherInfo||{isEmpty:true}"></ConfigDetailHq>
                  </div>
                </div>
              </div>
            </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import ConfigDetailHq from './config-detail-hq.vue'
import ConfigItemHq from './config-item-hq.vue'
import ConfigItemSecondSelect from './config-item-second-select.vue'
export default {
  name: 'cross-channel-pop',
  components: {
    ConfigDetailHq,
    ConfigItemSecondSelect,
    ConfigItemHq
  },
  data() {
    return {
      itemInfo: {},
      params: {
        themeStyles: []
      },
      secondActiveName: '',
      themeStyles: [],
      themeStylesValid: [],
      themeStylesValidOrder: [],
      themeStylesSecond: [],
      themeStylesSecondValid: [],
      editRules:{
        themeStyles: [{ required: true, message: "请选择活动形式", trigger: "blur" }],
        themeDecorateCodes: [{ required: true, message: "请选择装饰点位", trigger: "blur" }],
      },
      itemCount:0,
      btnType:'',
      showError:false,
      inputError:false,
      saveDetailList:[]
    }
  },
  props: {
    configItem: { type: Object, default: () => { } },
    fullConfig: { type: Array, default: () => [] },
    assignBuList: { type: Array, default: () => [] },
    assignRegionList: { type: Array, default: () => [] },
    assignAreaList:{ type: Array, default: () => [] },
    detailList: { type: Array, default: () => [] },
    saveDetailList1: { type: Array, default: () => [] },
  },
  created() {
    this.itemInfo = { ...this.configItem };
    for(let item of this.saveDetailList1){
      if(item&&(this.itemInfo.themeChannelCode===item[0].themeDetail.themeChannelCode)){
        this.saveDetailList = item
      }
    }
    //console.log(this.saveDetailList);
    // 遍历草稿
    if(this.saveDetailList.length>0){
      for(let i =0;i<this.saveDetailList.length;i++){
        let allInfo = this.saveDetailList[i]
        let item = this.saveDetailList[i].themeDetail
        // console.log(i);
        // console.log(item);
        let index = this.themeStyles.indexOf(item.themeStyleName)
        // 如果 themeStyle 里没有草稿对应的styleName
        if(index==-1){
          //console.log(item);
          if(item.themeLevelCode){
            let otherInfo = JSON.parse(JSON.stringify( allInfo ))
            delete otherInfo.themeDetail.themeStylesSecond
            item.otherInfo = otherInfo
            let data = JSON.parse(JSON.stringify( item ))
            item.themeStylesSecond = [ data ]
            for(let i=0;i<this.itemInfo.themeStyles.length;i++){
              if(this.itemInfo.themeStyles[i].themeStyleCode===item.themeStyleCode){
                this.itemInfo.themeStyles[i].themeStylesSecond = [ item ]
              }
            }
          }else {
            let otherInfo = JSON.parse(JSON.stringify( allInfo ))
            item.otherInfo = otherInfo
          }
          this.themeStyles.push(item.themeStyleName)
          this.themeStylesValid.push(item)
          this.themeStylesValidOrder.push(item)
          this.handleActivityFormChange()
        }else {
          // 有等级的活动形式都存在 活动形式 的themeStylesSecond中
          if(this.themeStylesValidOrder[index].themeStylesSecond){
            let otherInfo = JSON.parse(JSON.stringify( allInfo ))
            //delete otherInfo.themeDetail
            item.otherInfo = otherInfo
            this.themeStylesValidOrder[index].themeStylesSecond.splice(this.themeStylesValidOrder[index].themeStylesSecond.length,0,item)
          }else {
            let allInfo1 = JSON.parse(JSON.stringify(this.themeStylesValidOrder[index]))
            item.otherInfo = JSON.parse(JSON.stringify( allInfo ))
            let themeStylesSecond = [allInfo1,item]
            this.themeStylesValidOrder[index].themeStylesSecond = themeStylesSecond
          }
          for(let styleIndex=0;styleIndex<this.itemInfo.themeStyles.length;styleIndex++){
            // console.log(styleItem.themeStyleCode);
            // console.log(this.themeStylesValidOrder[index]);
            let styleItem = this.itemInfo.themeStyles[styleIndex]
            if(styleItem.themeStyleCode===this.themeStylesValidOrder[index].themeStyleCode){
              //console.log(item.themeStyleName);
              this.itemInfo.themeStyles[styleIndex].themeStylesSecond = this.themeStylesValidOrder[index].themeStylesSecond
            }
          }
        }
      }
    }else {
      //console.log(5566);
      for(let i=0;i<this.itemInfo.themeStyles.length;i++){
        this.itemInfo.themeStyles[i].themeStylesSecond = []
        //console.log(this.itemInfo.themeStyles[i]);
      }
    }
    //console.log(this.itemInfo.themeStyles);
    //console.log(this.params);
  },
  computed:{
    getConfigTitle(){
      return this.itemInfo.themeChannelEnName+"渠道设置"
    }
  },
  methods: {
    handleInputError(){
      this.inputError = true
    },
    handleActivityFormChange() {
      this.secondActiveName = this.themeStylesValidOrder[0] && this.themeStylesValidOrder[0].themeStyleName
    },
    handleThemeStylesValidOrder(){
      this.themeStylesValidOrder=[]
      for(let i of this.itemInfo.themeStyles){
        for(let selected of this.themeStylesValid){
          if(i.themeStyleName===selected.themeStyleName){
            this.themeStylesValidOrder.push(selected)
          }
        }
      }
      //console.log(this.themeStylesValidOrder);
    },
    submit(type){
      this.inputError = false
      this.btnType = type
      this.itemCount=0
      if(this.$refs.configDetailRef&&this.$refs.configDetailRef.length>0){
        for(let i=0;i<this.$refs.configDetailRef.length;i++){
          this.$refs.configDetailRef[i].submit(type)
        }
      }
      if(this.$refs.configDetailHq&&this.$refs.configDetailHq.length>0){
        for(let i=0;i<this.$refs.configDetailHq.length;i++){
          this.$refs.configDetailHq[i].submit(type)
        }
      }
    },
    isChecked(item) {
      return this.themeStyles.indexOf(item) !== -1
    },
    changeThemeStyles(item) {
      let isChecked = this.isChecked(item.themeStyleName)
      if (isChecked) {
        //if (!item.themeLevels || item.themeLevels.length == 0) {
          this.themeStylesValid.splice(this.themeStylesValid.length, 0, item)
        //}
      } else {
        for (let i = 0; i < this.themeStylesValid.length; i++) {
          if (this.themeStylesValid[i].themeStyleName === item.themeStyleName) {
            this.themeStylesValid.splice(i, 1)
          }
        }
      }
      this.handleThemeStylesValidOrder()
    },
    handleThemeStylesSecond(themeStylesSecondInfo) {
      let isExist = false
      for (let i = 0; i < this.themeStylesValid.length; i++) {
        if (themeStylesSecondInfo.themeStyleName === this.themeStylesValid[i].themeStyleName) {
          isExist = true
          if (themeStylesSecondInfo.themeStylesSecond&&themeStylesSecondInfo.themeStylesSecond.length > 0&&themeStylesSecondInfo.nextLevelRate) {
            this.themeStylesValid.splice(i, 1, themeStylesSecondInfo)
            this.handleThemeStylesValidOrder()
          } else {
            this.themeStylesValid.splice(i, 1,themeStylesSecondInfo)
            this.handleThemeStylesValidOrder()
            this.handleActivityFormChange()
          }
        }
      }
      // console.log(themeStylesSecondInfo);
      // console.log(this.themeStylesValid);
      if (!isExist && themeStylesSecondInfo.length > 0) {
          this.themeStylesValid.splice(this.themeStylesValid.length, 0, themeStylesSecondInfo)
          this.handleThemeStylesValidOrder()
          this.handleActivityFormChange()
      }
    },
    handleChangeStyle(themeStyleCode){
      if(this.$refs.configDetailHq instanceof Array){
        for(let item of this.$refs.configDetailHq){
          if(item._props.item.themeStyleCode === themeStyleCode){
            //item.handleChangeActiveName()
          }
        }
      }else if(this.$refs.configDetailHq._props.item.themeStyleCode === themeStyleCode){
        //this.$refs.configDetailHq.handleChangeActiveName()
      }
      //console.log(this.$refs.configDetailHq);
    },
    hasSecond(item) {
      //console.log("检查是否有等级",item.themeLevels && item.themeLevels.length > 0,item,item.themeLevels);
      return item.themeLevels && item.themeLevels.length > 0
    },
    hasRate(item){
      // return true
      return item.nextLevelRate
    },
    handleSubmit(detailItem,valid,type){
      this.itemCount+=1
      if(this.btnType==='submit'){
        this.$emit("handleSubmit",detailItem,valid,type)
      }else {
        this.$emit("handleSubmit",detailItem,valid,type)
      }
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #409EFF;
  border-color: #409EFF;
}

::v-deep .el-checkbox__inner:hover,
::v-deep .el-checkbox__input .el-checkbox__inner:focus {
  border-color: #409EFF !important;
}

::v-deep .el-checkbox__input.is-focus .el-checkbox__inner,
::v-deep .el-checkbox__input.is-focus .el-checkbox__inner:hover {
  border-color: #409EFF !important;
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #101010;
}

::v-deep .el-checkbox {
  height: 40px;
}

::v-deep .el-form-item {
  .el-form-item__label {
    color: black;
    font-weight: 600;
  }

  .el-form-item__content {
    line-height: 35px !important;
    margin: 3px;
  }
}
::v-deep .el-checkbox__input {
    margin-top: 0px !important;
}
.activity_form_box {
  width: calc(100% - 60px);
  margin-left: 30px;

  .activity_form_item {
    display: flex;
  }
}

.tab_box {
  margin-top: 20px;

  .tab_item_box {
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    border-top-right-radius: 8px;

    .tab_item_context {
      height: 100%;
      width: calc(100% - 40px);
      padding: 20px;
    }
  }
}

::v-deep .el-tabs {
  .el-tabs__nav {
    border: none;
    border-radius: 10px 10px 0px 0px;
  }

  .el-tabs__item.is-active {
    background: rgb(0, 153, 255);
    color: #fff;
  }

  .el-tabs__item {
    min-width: 100px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    height: 42px;
    display: inline-block;
    border: none;
    padding: 0 10px !important;
    background: #fff;
    margin-right: 3px;
    color: black;
    text-align: center;
  }

  .el-tabs__header {
    border-bottom: none;
    margin-bottom: 0;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    border-top-right-radius: 8px;
  }
}

::v-deep .tab_item_context .el-tabs {
  .el-tabs__nav {
    border: none;
    border-radius: 10px 10px 0px 0px;
    display: flex;
    flex-direction: column;
  }

  .el-tabs__item.is-active {
    color: rgb(0, 119, 255);
  }

  .el-tabs__item {
    min-width: 100px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    height: 42px;
    display: inline-block;
    border: none;
    padding: 0px !important;
    background: #fff;
    margin-right: 3px;
    color: black;
    text-align: center;
  }

  .el-tabs__header {
    border-bottom: none;
    margin-bottom: 0;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    border-top-right-radius: 8px;
  }
}
.no_data_tip{
  height: 100px;
  text-align: center;
  vertical-align: middle;
  font-size: 16px;
  margin-top: 80px;
}
.warning{
  margin-left: 140px;
  color: red;
}
</style>
